/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * GTM events for Account Page
 *
 * @author Julia Ignatieva
 * @version 1.12.0
 * @since 1.12.0
 */

import { IGTMOperation } from './index';

export const clickLinkCashbackControlAccountInfoPage = (url: string): IGTMOperation => ({
    'event': 'addEvents_makeActions',
    'event_id': 'd-v395-e3',
    'event_cat': 'Лицевой счет / Общая информация',
    'event_name': 'clickElement',
    'event_param': url,
});
